// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchResults-module__list--34evC","listItem":"SearchResults-module__listItem--38Dg6","result":"SearchResults-module__result--31ZUH"};